module.exports = __webpack_public_path__ + "static/img/12.0b1e364.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/16/sp/12.png
// module id = PTRH
// module chunks = 0